import React, { useEffect, useState } from 'react'
import Container from '../../../v2/Container'
import Image from '../../../Image'
import useQueryString from '../../../../hooks/use-query-string'
import landingPageImg from '../../../../assets/composites_background.jpg'
import { Package, Price, Student, StudentImage, Background } from '../../../../models'
import Fetching from '../Yearbooks/Fetching'
import ErrorState from '../Yearbooks/ErrorState'
import CompositeForm from './CompositeForm'
import useLocalStorage from '../../../../hooks/useLocalStorage';
import Typography from '../../../Typography';
import StudentImages from './StudentImages'
const ERROR = 'ERROR'
const DONE = 'DONE'
const FETCHING = 'FETCHING'

const useStudent = (params) => {
  const [student, setStudent] = useState()
  const [studentImages, setStudentImages] = useState([])
  const [status, setStatus] = useState(FETCHING)
  const { schoolId, accessCode, studentId } = params;

  useEffect(() => {
    setStatus(FETCHING)

    Student
      .includes('school')
      .where({ studentId, schoolId })
      .all()
      .then((res) => {
        let studentDbId

        if (res.data.length === 1) {
          setStudent(res.data[0])
          studentDbId = res.data[0].id
        } else {
          setStudent(res.data[res.data.length - 1])
          studentDbId = res.data[res.data.length - 1].id
        }

        StudentImage
          .where({ for_access_code_and_school: [accessCode, schoolId] })
          .all()
          .then(() => {
            if (res.data.length > 0) {
              StudentImage
                .where({ all_fall_images: studentDbId })
                .all()
                .then((response) => {
                  const sortedStudentImages = response.data.sort((a, b) => (
                    a.folder.match(/\d/g).join('') - b.folder.match(/\d/g).join('')
                  ))

                  setStatus(DONE)
                  setStudentImages(sortedStudentImages)
                })
            }
            else {
              setStatus(DONE)
            }
          })
      })
      .catch(() => {
        setStatus(ERROR)
      })
  }, [params.studentId, params.schoolId])

  return { student, studentImages, status }
}

export const useCompositePackage = (schoolId) => {
  const [composite, setComposite] = useState()
  const [status, setStatus] = useState(FETCHING)

  useEffect(() => {
    if (!schoolId) return

    const priceScope = Price.where({ for_school: schoolId })

    // schoolId is a plain attribute on Price, so CompositeForm can tell a
    // school-specific price from a generic one without sideloading
    // options.prices.school. (The Podesta Ranch "zero packages" incident was
    // blamed on that sideload; it was the server caching this query with its
    // clock frozen -- removed from Api::PackagesController, see
    // spec/requests/api/packages_cache_freshness_spec.rb.)
    Package
      .includes({ options: ['imageTypes', 'prices'] })
      .merge({ prices: priceScope })
      .where({ schoolId })
      .where({ has_prices_for_school: schoolId })
      .where({ name: { match: 'composite' } })
      .all()
      .then((res) => {
        if (res.data.length < 1) return

        setComposite(res.data[0])
      })
  }, [schoolId])

  return { composite, status }
}

const Composites = () => {
  const { sch: schoolId, sid: studentId, access_code: accessCode } = useQueryString()
  const { student, studentImages, status } = useStudent({ schoolId, studentId, accessCode })
  const { composite } = useCompositePackage(schoolId)
  const [_, setIsUsingAccessCode] = useLocalStorage('isUsingAccessCode')
  const [background, setBackground] = useState()

  useEffect(() => {
    Background
      .where({ color: 'El Blue' })
      .first()
      .then((response) => {
        setBackground(response.data)
      })
  }, [])

  setIsUsingAccessCode(true)

  if (status === FETCHING) return <Fetching />
  if (status === ERROR) {
    return <ErrorState message="We were unable to find your student. Please check back again later." />
  }

  if (!(student && composite && background) && status !== FETCHING) {
    return (
      <Typography align="center" fontStyle="italic">
        Composites are currently not available for your school. Please check back again later.
      </Typography>
    )
  }

  return (
    <Container maxWidth="lg">
      <StudentImages student={student} school={student.school}
                     studentImages={studentImages} background={background} />
      <CompositeForm student={student} school={student.school} studentImages={studentImages} composite={composite} />
    </Container>
  )
}

export default Composites
